import EventCard from '../components/Event/EventCard';
import MoodSnapshotCard from '../components/MoodSnapshot/MoodSnapshotCard';
import FacilityReportsCard from '../components/FacilityReports/FacilityReportsCard';
import TopAlarmersCard from '../components/TopAlarmers/TopAlarmersCard';
import LatestCheckInCard from '../components/LatestCheckIn/LatestCheckInCard';
import ScheduleCard from '../components/Schedule/ScheduleCard';
import LongestResponseCard from '../components/LongestResponse/LongestResponseCard';
import AverageResponseCard from '../components/AverageResponse/AverageResponseCard';
import AlarmHistoryCard from '../components/AlarmHistory/AlarmHistoryCard';
const componentMap = new Map();

componentMap.set('Mood Snapshot',MoodSnapshotCard);
componentMap.set('Most Alarms', TopAlarmersCard);
componentMap.set('Longest Responses', LongestResponseCard);
componentMap.set('Reports', FacilityReportsCard);
componentMap.set('Next Event', EventCard);
componentMap.set('Latest Check-in',LatestCheckInCard);
componentMap.set('Event Calendar',ScheduleCard);
componentMap.set('Avg Alarm Response', AverageResponseCard);
componentMap.set('Alarm History', AlarmHistoryCard);

export default componentMap;